export type BasicInfoShowWhen = "always" | "whenNotPagaleve";

export interface BasicInfoFieldConfig {
  id: string;
  labelKey: string;
  label?: string;
  getValue: (
    provider: Record<string, unknown>,
    mcc: string,
  ) => string | number | undefined;
  showWhen: BasicInfoShowWhen;
}

export const BASIC_INFO_FIELDS: BasicInfoFieldConfig[] = [
  {
    id: "name",
    labelKey: "provider",
    getValue: (p) => (p.name as string) ?? "",
    showWhen: "always",
  },
  {
    id: "state",
    labelKey: "status",
    getValue: (p) => (p.state as string) ?? "",
    showWhen: "always",
  },
  {
    id: "priority",
    labelKey: "usagePriority",
    getValue: (p) => (p.priority as number) ?? 0,
    showWhen: "whenNotPagaleve",
  },
  {
    id: "mcc",
    labelKey: "mcc",
    label: "MCC",
    getValue: (_p, mcc) => mcc || "",
    showWhen: "whenNotPagaleve",
  },
  {
    id: "merchantId",
    labelKey: "mainMerchantId",
    getValue: (p) => {
      const acquirer = p.acquirer as { merchantId?: string } | undefined;
      return acquirer?.merchantId ?? "";
    },
    showWhen: "whenNotPagaleve",
  },
];

export const CREDENTIAL_KEY_LABELS: Record<string, string> = {
  secretKey: "Secret Key",
  merchantKey: "Merchant Key",
  merchantId: "Merchant ID",
  email: "E-mail / Login",
  token: "Token de API",
  apiKey: "API Key",
  subsidiaryId: "ID Subsidiária",
  sellerId: "Seller ID",
  clientApiKey: "Client API Key",
  clientSecret: "Client Secret",
  "Subsidiary Id": "ID Subsidiária",
};

function formatKeyAsLabel(key: string): string {
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (s) => s.toUpperCase())
    .trim();
}

export function getCredentialLabel(
  key: string,
  titleFromSchema?: string,
): string {
  if (CREDENTIAL_KEY_LABELS[key]) {
    return CREDENTIAL_KEY_LABELS[key];
  }
  if (titleFromSchema && titleFromSchema.trim() !== "") {
    return titleFromSchema.trim();
  }
  return formatKeyAsLabel(key);
}
